module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Noble-Contree_COA_alt-af923a5af519e19376c8bfd9182ab6d0.svg";